import React from 'react'

import { fetchAndReturn } from 'data/utils/utils'
import { RerunMessagesModal } from 'features/common/RerunMessagesModal'
import { ConfigurationLabel } from 'features/workflows/WorkflowUI'

import { WorkflowTriggerEditorComponent } from './types'

export const EmailReceivedTriggerConfig: WorkflowTriggerEditorComponent = ({
    trigger,
    workflow,
}) => {
    const rerunWorkflowMessages = React.useCallback(
        async (messageIds: string[]) => {
            await fetchAndReturn(`flows/rerun-messages/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    flow_sid: workflow._sid,
                    message_ids: messageIds,
                }),
            })
        },
        [workflow._sid]
    )

    if (!trigger.settings?.connection_id) return null

    return (
        <>
            <ConfigurationLabel>Re-run messages</ConfigurationLabel>
            <RerunMessagesModal rerunFn={rerunWorkflowMessages} />
        </>
    )
}
